import {Component} from '@angular/core';
import {environment} from "../environments/environment";
import {AppConfiguration} from "./app.configuration";
import {ProgressManagerService} from "@vhv/tarifrechner-common";
import {RateBaugeraeteService} from "../rate/rate-baugeraete.service";
import {DownloadBaugeraeteService} from "../service/download-baugeraete.service";
import {VersicherungsablaufBaugeraeteService} from "../service/versicherungsablauf-baugeraete.service";


@Component({
    selector: 'vhv-app-root',
    templateUrl: './app.component.html',
    host: { 'class': 'app-root' },
})
export class AppComponent {

    public version: string = environment.version;

    //wenn der Constructor fehlt wird auf den ebene ein logging error geschmissen
    constructor(
        private appConfig: AppConfiguration,
        private progressManagerService: ProgressManagerService,
        private rateBaugeraeteService: RateBaugeraeteService,
        private downloadService: DownloadBaugeraeteService,
        private versicherungsablaufService: VersicherungsablaufBaugeraeteService,
    ) {
        (window as any)['dataLayer'].push({
            'prozess_version': this.version
        });
    }

    onActivate(event:any) {
        window.scroll(0,0);
    }
}
